import lodash from 'lodash'

window.lodash = lodash